import type { Instance, Response, RiskConfig } from '@/models/api-generated'
import http from '@/services/http'
import { defaultInstance } from '@/services/utils'
import { ref } from 'vue'

function defaultRiskConfig() {
	return {
		id: 0,
		catalogs: [],
		matrixSize: 4,
		acceptableRisk: 8,
		riskLevels: [],
		riskImpacts: [],
		riskProbabilities: [],
		instance: defaultInstance(),
	}
}

export async function getRiskConfig() {
	const { data } = await http.get<Response<RiskConfig>>('api/risk/config')
	if (data.data) riskConfig.value = data.data
	return data.data ?? defaultRiskConfig()
}

export const riskConfig = ref<RiskConfig>(defaultRiskConfig())
